const maxUInt32Value = 4294967295;
/**
 * Utilises crypto.randomBytes to generate a secure random number.
 * This is meant to be used as a secure replacement for Math.random().
 *
 * @returns A random number between 0 and 1.
 */
export function secureRandom() {
    return crypto.getRandomValues(new Uint32Array(1))[0] / maxUInt32Value;
}
